module.exports = __webpack_public_path__ + "static/media/manualTransfer.49e6e03b.svg";